window['$notify'] = params => new ToastMagic()[params.type](params.message);

const MOBILE_CART_OVERLAY_QUERY = '(max-width: 767px)';

let suppressSuccessToastForMobileCart = false;

function isMobileCartOverlayViewport() {
    return window.matchMedia(MOBILE_CART_OVERLAY_QUERY).matches;
}

function markMobileCartOverlayOpening() {
    if (!isMobileCartOverlayViewport()) {
        return;
    }

    suppressSuccessToastForMobileCart = true;
    window.setTimeout(() => {
        suppressSuccessToastForMobileCart = false;
    }, 50);
}

window.addEventListener('open-cart-sidebar', markMobileCartOverlayOpening);

document.addEventListener('notify', (params) => {
    const [type, ...rest] = params.detail;

    if (
        type === 'success'
        && suppressSuccessToastForMobileCart
        && isMobileCartOverlayViewport()
    ) {
        return;
    }

    const toast = new ToastMagic();

    toast[type](...rest);
});
